import FilterModal from './FilterModal';
import './Filtros.css';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import FilterProposta from "./FilterProposta";

function Filtros({ filtro, setFiltro, chatHistory, assistantId, sessionId }) {
    const { t: tCommon } = useTranslation('common');
    const [isFilterModal, setIsFilterModal] = useState(false);

    const [selectedCliente, setSelectedCliente] = useState([]);
    const [selectedProposta, setSelectedProposta] = useState([]);
    const [selectedArea, setSelectedArea] = useState([]);
    const [selectedServico, setSelectedServico] = useState([]);

    const [selectedSectors, setSelectedSectors] = useState([]);
    const [selectedSubsectors, setSelectedSubsectors] = useState({
        building: [],
        environment: [],
        transport: []
    });
    const [selectedCountries, setSelectedCountries] = useState([]);

    useEffect(() => {
        if (chatHistory && chatHistory.length > 0) {
            console.log(chatHistory)
            const ultimaComFiltro = [...chatHistory].reverse().find(
                msg => msg.filters && Object.keys(msg.filters).length > 0
            );

            if (ultimaComFiltro) {
                setFiltro(ultimaComFiltro.filters);

                console.log(ultimaComFiltro);

                if (assistantId === '182') {
                    setSelectedCliente((ultimaComFiltro.filters.cliente || []).map(c => ({ value: c, label: c })));
                    setSelectedProposta((ultimaComFiltro.filters.proposta || []).map(p => ({ value: p, label: p })));
                    setSelectedArea((ultimaComFiltro.filters.area || []).map(a => ({ value: a, label: a })));
                    setSelectedServico((ultimaComFiltro.filters.servico || []).map(s => ({ value: s, label: s })));
                }
                else if (assistantId === '1') {
                    setSelectedSectors((ultimaComFiltro.filters.sectors || []).map(s => ({ value: s, label: s })));
                    setSelectedSubsectors(ultimaComFiltro.filters.subsectors || { building: [], environment: [], transport: [] });
                    setSelectedCountries((ultimaComFiltro.filters.countries || []).map(c => ({ value: c, label: c })));
                }
            } else {
                // nenhum filtro salvo → limpa
                setFiltro({});
                setSelectedCliente([]);
                setSelectedProposta([]);
                setSelectedArea([]);
                setSelectedServico([]);
                setSelectedSectors([]);
                setSelectedSubsectors({ building: [], environment: [], transport: [] });
                setSelectedCountries([]);
            }
        }
    }, [assistantId, sessionId]);


    // Função para atualizar os filtros
    const applyFilters = () => {
        if (assistantId === '1') {
            const sectorValues = selectedSectors.map(s => s.value);
            const countryValues = selectedCountries.map(c => c.value);

            const filtroFinal = {
                sectors: sectorValues,
                subsectors: selectedSubsectors,
                countries: countryValues
            };

            setFiltro(filtroFinal);
        }
        else if (assistantId === '182') {
            const filtroFinal = {
                cliente: selectedCliente.map(c => c.value),
                proposta: selectedProposta.map(p => p.value),
                area: selectedArea.map(a => a.value),
                servico: selectedServico.map(s => s.value),
            };

            setFiltro(filtroFinal);
        }

    };

    if (assistantId === '1') {
        // Código que você já tem
        return (
            <div className="filtros-container" data-testid="filtros-container">
                <img
                    src={
                        selectedSectors.length === 0 &&
                            Object.values(selectedSubsectors).every(arr => arr.length === 0) &&
                            selectedCountries.length === 0
                            ? "/imagens/filtro.svg"
                            : "/imagens/filtro_cheio.svg"
                    }
                    alt={tCommon("filterIcon")} 
                    className='filter-icon'
                    onClick={() => setIsFilterModal(true)}
                />

                <FilterModal
                    isOpen={isFilterModal}
                    onClose={() => setIsFilterModal(false)}
                    selectedSectors={selectedSectors}
                    setSelectedSectors={setSelectedSectors}
                    selectedSubsectors={selectedSubsectors}
                    setSelectedSubsectors={setSelectedSubsectors}
                    selectedCountries={selectedCountries}
                    setSelectedCountries={setSelectedCountries}
                    applyFilters={applyFilters}
                />
            </div>
        );
    } else if (assistantId === '182') {
        // Novo código que você vai criar
        return (
            <div className="filtros-container" data-testid="filtros-container-propostai">
                <img
                    src={
                        selectedCliente.length === 0 &&
                            selectedProposta.length === 0 &&
                            selectedArea.length === 0 &&
                            selectedServico.length === 0
                            ? "/imagens/filtro.svg"
                            : "/imagens/filtro_cheio.svg"
                    }
                    alt="Ícone de filtro"
                    className='filter-icon'
                    onClick={() => setIsFilterModal(true)}
                />

                <FilterProposta
                    isOpen={isFilterModal}
                    onClose={() => setIsFilterModal(false)}
                    selectedCliente={selectedCliente}
                    setSelectedCliente={setSelectedCliente}
                    selectedProposta={selectedProposta}
                    setSelectedProposta={setSelectedProposta}
                    selectedArea={selectedArea}
                    setSelectedArea={setSelectedArea}
                    selectedServico={selectedServico}
                    setSelectedServico={setSelectedServico}
                    applyFilters={applyFilters}
                />

            </div>
        );
    }
}

export default Filtros;